export default __webpack_public_path__ + "static/media/envsensor_realtime_updated_at.0a2cba49.svg";